import { catchError, tap, switchMap, map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';
import { ConfigService } from '@app/core/config.service';
import { COOKIES, ENDPOINTS, DEFAULT_APP_VALUES, AFFILIATION_TYPES } from '@app/app.constants';
import * as i0 from "@angular/core";
import * as i1 from "../authentication/authentication.service";
import * as i2 from "../../config.service";
import * as i3 from "ngx-cookie-service/cookie-service/cookie.service";
import * as i4 from "@angular/common/http";
export class ProfileService {
    constructor(authenticationService, configService, cookieService, httpClient) {
        this.authenticationService = authenticationService;
        this.configService = configService;
        this.cookieService = cookieService;
        this.httpClient = httpClient;
        this.cookies = COOKIES;
        this.webApiUrl = this.configService.getValue('webApiUrl');
    }
    /**
     * Returns list of affiliations (e.g. PASSHOLDER, FL_RESIDENT etc)
     * @returns Observable of Affiliations
     */
    getAffiliations() {
        return this.authenticationService.isLoggedIn().pipe(switchMap((isLogged) => {
            if (isLogged) {
                if (this.affiliations) {
                    return of(this.affiliations);
                }
                else {
                    const SWID = this.cookieService.get(COOKIES.SWID);
                    const affiliationsUrl = `${this.webApiUrl}${ENDPOINTS.affiliations}`.replace('{swid}', SWID);
                    return this.httpClient.get(affiliationsUrl)
                        .pipe(map((response) => {
                        const affiliations = [];
                        // Just only use ther first affiliation with affiliationType === CASTAWAYCLUB
                        const firstAffilliation = response.entries.find((entry) => entry.affiliationType === AFFILIATION_TYPES.CASTAWAY);
                        if (firstAffilliation) {
                            affiliations.push({
                                affiliationType: firstAffilliation.affiliationType,
                                affiliationLevel: firstAffilliation.affiliationLevel || firstAffilliation.level,
                                affiliationId: firstAffilliation.affiliationId || firstAffilliation.clubId
                            });
                        }
                        return affiliations;
                    }), tap((response) => this.affiliations = response), catchError(() => {
                        // TODO: The error handling for this http call should be updated
                        // when the specification for errors is defined
                        return of(DEFAULT_APP_VALUES.affiliations);
                    }));
                }
            }
            else {
                return of(DEFAULT_APP_VALUES.affiliations);
            }
        }));
    }
}
ProfileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProfileService_Factory() { return new ProfileService(i0.ɵɵinject(i1.AuthenticationService), i0.ɵɵinject(i2.ConfigService), i0.ɵɵinject(i3.CookieService), i0.ɵɵinject(i4.HttpClient)); }, token: ProfileService, providedIn: "root" });
